import React from "react";
import FloatingChatWidget from "../components/FloatingChatWidget";

const FundraisingFooter = () => {
    return (
        <>
            <footer className="pt-4 pt-lg-5 pb-3 font-size-16">
                <div className="container">
                    <div className="row justify-content-between mb-lg-4 py-4 align-items-center">
                        {/* Logo + Text */}
                        <div className="col-md-7 col-lg-6 col-xl-6 col-xxl-5 mb-4 line-hight-4">
                            <div className="d-flex align-items-center">
                                <div className="me-4 footer-logo">
                                    <img src="/assets/images/logo.png" className="img-fluid" />
                                </div>
                                <div className="ps-2">
                                    <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">The Just Generation Foundation is building one welcoming place where children of every ability learn side by side and families can ask questions early.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 col-lg-4 col-xl-3 mb-md-4">
                            <h6 className="font-weight-semibold font-size-24 montserrat">Our Newsletter</h6>
                            <form className="d-flex mb-3 position-relative newsletter-box">
                                <input type="email" className="form-control ps-4 newsletter-input rounded-pill" placeholder="Your email address" />
                                <button className="btn newsletter-btn position-absolute rounded-pill" type="submit">
                                    <i className="fa fa-paper-plane-o" aria-hidden="true"></i>
                                </button>
                            </form>
                        </div>
                    </div>
                    <div className="row">
                        {/* Quick Links */}
                        <div className="col-lg-8 col-xl-9">
                            <div className="row">
                                {/* Quick Links */}
                                <div className="col-md-4 col-xl-3 mb-4">
                                    <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Quick Links</h6>
                                    <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                                        <li className="my-2 pt-lg-1 col"><a href="/about">About</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_PROVIDER_SIGNUP}>Providers</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_SIGNUP}>Parents</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_CONTACT}>Contact</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_PRIVACY_POLICY}>Privacy Policy</a></li>
                                    </ul>
                                </div>

                                {/* Other Links */}
                                <div className="col-md-4 col-xl-3 mb-4">
                                    <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Other Links</h6>
                                    <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_CONTACT}>Contact Us</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_FAQS}>FAQs</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_BLOGS}>Blogs</a></li>
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_CAREERS}>Career</a></li>
                                        {/* <li className="my-2 pt-lg-1 col"><a href="#">Treats Glaucoma</a></li> */}
                                    </ul>
                                </div>
                                {/* Information */}
                                <div className="col-md-4 col-xl-3 mb-4">
                                    <h6 className="font-weight-semibold font-size-24 montserrat mb-4">Information</h6>
                                    <ul className="list-unstyled row row-cols-2 row-cols-md-1">
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_PRIVACY_POLICY}>Privacy Policy</a></li>
                                        {/* <li className="my-2 pt-lg-1 col"><a href="#">Shipping Policy</a></li> */}
                                        <li className="my-2 pt-lg-1 col"><a href={process.env.REACT_APP_CLIENT_TERMS}>Terms & Conditions</a></li>
                                        {/* <li className="my-2 pt-lg-1 col"><a href="#">Refund and Returns Policy</a></li> */}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* Newsletter & Contact */}
                        <div className="col-lg-4 col-xl-3 mb-4">
                            <ul className="list-unstyled row row-cols-1 row-cols-md-3 row-cols-lg-1 align-items-center">
                                <li className="footer-icon col">
                                    <div className="d-flex align-items-center">
                                        <i className="me-3"><img src="/assets/images/footer-address.svg" className="img-fluid" /></i>
                                        <div>
                                            <h6 className="font-weight-semibold font-size-18 montserrat">Address</h6>
                                            <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">P.O. Box 4656, Norfolk, Virginia 23523</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="footer-icon col my-3">
                                    <div className="d-flex align-items-center">
                                        <i className="me-3"><img src="/assets/images/footer-call.svg" className="img-fluid" /></i>
                                        <div>
                                            <h6 className="font-weight-semibold font-size-18 montserrat">Phone Number</h6>
                                            <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">+(757) 276-3191</p>
                                        </div>
                                    </div>
                                </li>
                                <li className="footer-icon col">
                                    <div className="d-flex align-items-center">
                                        <i className="me-3"><img src="/assets/images/footer-gmail.svg" className="img-fluid" /></i>
                                        <div>
                                            <h6 className="font-weight-semibold font-size-18 montserrat">Contact Info</h6>
                                            <p className="mb-0 font-size-16 font-weight-normal line-hight-3 text-white">Info@justgen.org</p>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                                       {/* Virginia Charitable Solicitation Disclosure */}
                    <div className="row">
                        <div className="col-12">
                            <p className="small text-center text-white">
                                A financial statement is available upon request from the Virginia Department of Agriculture and Consumer Services, Office of Charitable and Regulatory Programs, P.O. Box 526, Richmond, VA 23218.
                            </p>
                        </div>
                    </div>

                    {/* Bottom Footer */}
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center footer-bottom d-sm-flex align-items-center justify-content-center">
                                <div className="font-weight-semibold font-size-16">
                                    <b className="montserrat font-weight-semibold font-size-20">Sattu baby care: </b>
                                    <a href="mailto:info@JGF.in">
                                        <i className="fa fa-at me-1" aria-hidden="true"></i> Info@justgen.org
                                    </a>
                                    {" | "}
                                    <a href="tel:+9145798799">+(757) 276-3191</a>
                                </div>
                                <div className="social-icons ms-sm-2">
                                    <a href="https://www.facebook.com/profile.php?id=61575600418282" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-facebook"></i>
                                    </a>
                                    <a href="https://www.linkedin.com/company/107183458/admin/dashboard/" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-linkedin"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Copyright */}
                    <div className="row mt-3">
                        <div className="col-12">
                            <p className="mb-0 text-center">
                                Copyright © The Just Generation Foundation
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
            <FloatingChatWidget />
        </>
    );
};

export default FundraisingFooter;
